export const DEFAULT_LANGUAGE = 'it'
export const FALLBACK_LANGUAGE = 'it'
export const SUPPORTED_LANGUAGES = ['en', 'it','de','fr','es','cs']
